// extracted by css-extract-rspack-plugin
export default {"parentIssuesList":"ParentIssueAddedEvent-module__parentIssuesList__OzJXD","parentIssueItem":"ParentIssueAddedEvent-module__parentIssueItem__CnsrX"};